import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mandanten-select"
export default class extends Controller {
	static targets = ["mandant"]

	connect() {}

	select({ currentTarget }) {
		// Alle Mandantenelemente entfärben
		this.mandantTargets.forEach((element) => {
			element.classList.remove("bg-spotlight", "text-white")
		})

		// Ausgewähltes Mandantenelement einfärben
		currentTarget.classList.add("bg-spotlight", "text-white")
	}
}
